const OfferScopeCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_remove_single',
	'title_notes_view',
	'title_notes_edit',
	'field_name_label',
	'field_name_placeholder',
	'field_cap_label',
	'field_cap_placeholder',
	'field_cap_type_label',
	'field_cap_type_placeholder',
	'field_status_label',
	'field_status_placeholder',
	'field_notes_label',
	'field_notes_placeholder',
	'msg_remove_confirm',
	'btn_create',
	'btn_update',
	'btn_remove',
	'btn_close'
] as const

type IOfferScopeCrudModalLangKey = typeof OfferScopeCrudModalLangKey[number]

export type IOfferScopeCrudModalLang = {
	offer_scope_crud_modal: Record<IOfferScopeCrudModalLangKey, string>
}

const langEntries = OfferScopeCrudModalLangKey.map(
	(key: IOfferScopeCrudModalLangKey) => [key, `offer_scope_crud_modal.${key}`]
)

const langObj: Record<IOfferScopeCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SCOPE_CRUD_MODAL_LANG_KEY: IOfferScopeCrudModalLang = {
	offer_scope_crud_modal: langObj
}